import { DataUnitofMeasureInfo } from './../../model/selfcareproducts';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { UserModel } from './../../model/UserModel';
import { ProductService } from 'src/app/services/product.service';
import { UserDetailResult, Product } from './../../model/UserDetail';
import { AccountService } from 'src/app/services/account.service';
import { PaymentService } from 'src/app/services/payment.service';
import { environment } from 'src/environments/environment';
import { ProductResult, ProductApiResponse } from './../../model/Product';
import { KeyValuePair, ServicePlan } from './../../model/RenewPlan';
import { SharedService } from './../../services/shared.service';
import { Component, OnInit } from '@angular/core';
import { RenewPlanModel } from 'src/app/model/RenewPlan';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CyberPaySetTransactionRequest, CyberPayLogModel } from 'src/app/model/CyberPay';
import { ActiveSessionsReqObj } from 'src/app/model/ApiRequests/ApiReqObj';
import { IfStmt } from '@angular/compiler';
import { throwError } from 'rxjs';
import { IVATModel } from '../../model/CyberPay';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-renewplan',
  templateUrl: './renewplan.component.html',
  styleUrls: ['./renewplan.component.css']
})
export class RenewplanComponent implements OnInit {
  // installment:boolean = false;
  allIn = true;
  vatModel: IVATModel = {VAT: 0, VatPercentage: 0, ProdVatPrice: 0 } as IVATModel;



  processing = false;
  tranSuccess = false;
  tranFailed = false;
  pagetitle: string;
  currentUser: UserModel;
  userdetail: UserDetailResult = {} as UserDetailResult;
  renewModel: RenewPlanModel = {} as RenewPlanModel;
  period: KeyValuePair[];
  selectedPeriod = 0;
  newServicePlanId = 0;
  newServicePlan: string;
  newServicePlanPrice: string;
  timeSlot: string;
  speed: string;
  capacity: string;
  newCapacity:string;
  validity: string;
  paymentMethod: string;
  selectedPlan: Product = {} as Product;
  filteredselfcareproduct: ProductResult[] = [] as ProductResult[];
  totalAmount: any;
  customerBalance: number;
  changePlan: boolean;
  constructor(private activatedRoute: ActivatedRoute, private productService: ProductService, private accountService: AccountService, private paymentService: PaymentService, private router: Router, private toastr: ToastrService, private sharedService: SharedService, private authenticationService: AuthenticationService) {
    this.currentUser = this.authenticationService.getCurrentUser();

    if (this.currentUser.i_Account == '0') {
      const KycStatus: string = this.currentUser.KycStatus;

      if (KycStatus) {
        if (KycStatus.toLowerCase() === 'Rejected'.toLowerCase() || KycStatus.toLowerCase() === 'No Kyc'.toLowerCase()) {
          this.router.navigate(['/kyc']);

        }


      }
    }
  }

  async ngOnInit() {

    this.period = this.sharedService.getPeriod();
    this.currentUser = this.authenticationService.getCurrentUser();

    const acc: number = parseInt(this.activatedRoute.snapshot.queryParamMap.get('acc'));
    const changePlan = this.activatedRoute.snapshot.queryParamMap.get('changeplan');
    this.changePlan = changePlan == 'true' ? true : false;
    this.pagetitle = this.changePlan ? 'Change Plan' : 'Renew Plan';

    if (!acc) {
      this.toastr.error('Error getting service plan details', 'Error');
      this.router.navigateByUrl('/dashboard');
      return;
    }



    // this.getRenewalObject(acc);
    await this.getRenewalObjectAsync(acc);


  }



  UserIsAuthourised(i_account: string, i_customer: string) {
    // deny unauthourised individual accounts
    if (this.currentUser.i_Account != '0') {

      if (this.currentUser.i_Account != i_account) {
        return false;
      }

    } else {

      // deny unauthorised customer accounts
      if (this.currentUser.i_Customer != i_customer) {
        return false;
      }

    }
    return true;
  }

  async getRenewalObjectAsync(i_account: number) {

    const model: ActiveSessionsReqObj = {} as ActiveSessionsReqObj;
    model.i_account = i_account;
    model.DownloadType = 'ACC:GetDetail';

    // let userdetailResult = await this.accountService.getActiveSessionsFromLteHttp(model).toPromise();
    const userdetailResult = await this.accountService.getAccountDetailFromLteHttp(model.i_account).toPromise();

    if (!userdetailResult.Status) {
      this.toastr.error(environment.GenericErrorMsg);
      return;
    }

    // let userdetail = userdetailResult.Result[0];
    const userdetail = userdetailResult.Result;

    this.userdetail = userdetail;

    if (!this.userdetail.i_account) {
      this.toastr.error(environment.GenericErrorMsg);
      return;
    }

    if (!this.UserIsAuthourised(this.userdetail.i_account.toString(), this.userdetail.i_customer.toString())) {
      this.toastr.error(environment.GenericErrorMsg, 'Error');
      return;
    }

    const productResult = await this.productService.getSingleProductsFromLte(userdetail.Product.i_product).toPromise();


    this.renewModel.AccountMdn = userdetail.ID.toString();
    this.renewModel.CurrentProduct = productResult.Result;
    this.renewModel.RemainingVolume = parseFloat((Math.round((userdetail.DataVolume) * 100) / 100).toString()).toFixed(2) + DataUnitofMeasureInfo[this.renewModel.CurrentProduct.Display.DataCapacity.UnitofMeasure];

    const allProductsResult = await this.productService.getAllProductsFromLte().toPromise();

    if (!allProductsResult.Status) {
      this.toastr.error(environment.GenericErrorMsg, 'Error');
      return;
    }




    if (this.changePlan) {

      const selfcareproduct: ProductResult[] = allProductsResult.Result;

      this.filteredselfcareproduct = selfcareproduct.filter((product) => product.i_product != this.renewModel.CurrentProduct.i_product && product.Display.ShowonSelfcare === true && product.Display.CanRenew === true && product.voip_id_tariff === 0).sort((a, b) => a.Price - b.Price);

      const serviceplan: ServicePlan[] = this.filteredselfcareproduct.map(a => {
        return {
          Id: a.i_product,
          PlanName: a.Name,
          PlanAmount: a.Price.toString()
        } as ServicePlan;
      });

      this.renewModel.ServicePlanList = serviceplan;
    } else {

      if (!this.renewModel.CurrentProduct.Display.CanRenew) {

        this.toastr.error('Error, Renewal is not available on this plan');
        return;
      }

      const selectedPlan: Product = productResult.Result;
      this.selectedPlan = selectedPlan;

      this.newServicePlan = selectedPlan.Name + ' ' + selectedPlan.Price;
      this.newServicePlanId = selectedPlan.i_product;
      this.timeSlot = selectedPlan.Display.TimeSlot;
      this.speed = selectedPlan.Display.BustableSpeed;
      this.capacity = selectedPlan.Display.DataCapacity.Capacity.toString() + DataUnitofMeasureInfo[selectedPlan.Display.DataCapacity.UnitofMeasure];
      this.validity = selectedPlan.Validity.toString() + 'Month';


    }

    const customerBalanceResult = await this.accountService.getCustomerBalance(userdetail.i_customer).toPromise();
    this.customerBalance = Math.round(customerBalanceResult.Result);

  }
  async setSelectedPaymentMethod(option: string) {
    if (option) {

      this.paymentMethod = option;
      if (this.selectedPeriod > 0) {

        if (this.allIn != false || this.paymentMethod == 'wallet') {
          await this.onAllIn();
        }


      }
    }
  }
  async onInstallment() {
    // this.installment=true;
    this.allIn = false;
    if (this.selectedPeriod > 0) {
      {
       await this.getVatValue(this.selectedPlan.Price);

       this.calculatePrice();
       const bull = (this.selectedPlan.Price * this.selectedPeriod) + this.vatModel.VAT;

      }
    }
  }
  async onAllIn() {
    this.allIn = true;
    const amount = this.selectedPlan.Price * parseInt(this.selectedPeriod.toString()) ;

    const res = await this.getVatValue(amount);

    const h = this.vatModel.VAT;
    this.calculatePrice();

    // this.installment=false;
  }

  async getVatValue(amount) {
    try {
      const vatResult = await this.paymentService.GetVAT(amount).toPromise();

      if (vatResult.Status != 1) {
        this.toastr.error('Error, VAT retrieval failed');
        return;
      }
      const vatres: IVATModel = vatResult.Result;
      this.vatModel = vatres;
      return vatres;
    } catch (e) {
      console.log(e);
      this.toastr.error('Error, VAT retrieval failed');
      // return;
    }
  }

  calculatePrice() {
    const period = parseInt(this.selectedPeriod.toString());

    if (this.allIn === false) {

      this.totalAmount = this.selectedPlan.Price * period + this.vatModel.VAT;
    } else {
      this.totalAmount = (period * this.selectedPlan.Price) + this.vatModel.VAT;
      console.log(this.totalAmount);
    }
  }

  getSelectedPeriod(id: number) {
    if (this.selectedPeriod > 0) {
      if (this.allIn === true) { this.onAllIn(); } else { this.onInstallment(); }


      // this.calculatePrice();
      //  this.getVatValue(this.selectedPlan.Price * this.selectedPeriod);
    }
  }



  getSelectedPlan(id: number) {
    const selectedPlan = this.filteredselfcareproduct.find(e => e.i_product == id);
    this.selectedPlan = selectedPlan;

    this.newServicePlan = selectedPlan.Name + ' ' + selectedPlan.Price;
    this.timeSlot = selectedPlan.Display.TimeSlot;
    this.speed = selectedPlan.Display.BustableSpeed;
    this.capacity = selectedPlan.Display.DataCapacity.Capacity.toString() + 'GB';
    this.validity = selectedPlan.Validity.toString() + 'Month';

    const newCapacity=(this.selectedPlan.Display.DataCapacity.Capacity * this.userdetail.Balance)/this.selectedPlan.FundPrice;
    this.newCapacity=newCapacity.toString() + 'GB';
    // this.paymentMethod = "CyberPay";
    if (this.selectedPeriod > 0) {
      this.calculatePrice();
    }

  }







  Proceeds() {

    if (!this.selectedPlan.Display.CanRenew) {
      this.toastr.error('Error, Renewal is not available on this plan');
      return;
    }

    if (this.paymentMethod == 'cyberpay') {
      this.gotoCyberPay();
    } else if (this.paymentMethod == 'wallet') {
      this.PayWithWallet();
    }

    return;
  }

  async PayWithWallet() {

    if (this.currentUser.i_Account != '0') {
      this.toastr.error('Not available for individual accounts');
      return;
    }
    try {
      this.processing = true;
      const userdetail = this.userdetail;

      if (userdetail == undefined) {
        this.toastr.error(environment.GenericErrorMsg, 'Error');
        this.processing = false;
        return;
      }

      if (this.customerBalance < this.totalAmount) {
        this.toastr.error('Your DataReserve Balance is not sufficient for transaction', 'insufficient balance');
        this.processing = false;
        return;
      }

      const itemName = this.renewModel.CurrentProduct.i_product == this.selectedPlan.i_product ? 'Account Renewal' : 'Service Change';

      const createBy: string = this.currentUser.UserName;

      if (itemName == 'Account Renewal') {
        const vatAmount = this.vatModel.VAT;
        const vatRate = this.vatModel.VatPercentage;
        const res = await this.paymentService
          .LteRenewPlanAccountRenewal(userdetail.i_customer, userdetail.i_account, this.totalAmount, createBy, vatAmount, vatRate).toPromise();

        if (res.Status) {
          this.processing = false;
          this.tranSuccess = true;
          this.clearform();
          return;
        }

        this.processing = false;
        this.tranFailed = true;
      } else if (itemName == 'Service Change') {


       const vatAmount = this.vatModel.VAT;
       const vatRate = this.vatModel.VatPercentage;
       const vatprod = this.vatModel.ProdVatPrice;

       const res = await this.paymentService.LteRenewPlanServiceChange(userdetail.i_customer, userdetail.i_account, this.selectedPlan.i_product, userdetail.ID, this.totalAmount, vatAmount, vatprod, vatRate).toPromise();

       if (res.Status) {
          this.processing = false;
          this.tranSuccess = true;
          this.clearform();
          return;
        }

       this.processing = false;
       this.tranFailed = true;
      }
    } catch (err) {
      this.processing = false;
      this.tranFailed = true;
    }

  }
   Proceed() {
     
    if(this.userdetail.block==environment.pausedAccId){
      this.toastr.error("You cannot renew a paused account. Please contact Customer Care");
      return;
    }
    const itemName = this.renewModel.CurrentProduct.i_product == this.selectedPlan.i_product ? 'Account Renewal' : 'Service Change';
    const producttype = this.renewModel.CurrentProduct.Display.DataCapacity.UnitofMeasure;
    const unlimitedtype = 9;
    const capacity = this.selectedPlan.Display.DataCapacity.Capacity;
    const planChangingTo = this.selectedPlan.Display.DataCapacity.UnitofMeasure;
    const newCapacity = (this.selectedPlan.Display.DataCapacity.Capacity * this.userdetail.Balance)/ this.selectedPlan.FundPrice;
    const period = parseInt(this.selectedPeriod.toString());
    const totalgb=capacity*period;

    let textmessage= `Note that Existing Validity(if any) will be lost. Due to  difference in tariff, your existing data will be recalculated; Recalcualted Rollver Data(${this.newCapacity}GB) + New Subscrption(${totalgb}GB) = Total(${newCapacity+totalgb}GB). Validity will be based on new Subscription plan`;
    
    if (itemName == 'Account Renewal') {
  console.log(this.renewModel);
  if (producttype == unlimitedtype) {
    this.Proceeds();
    } 
    else {
      textmessage = `Note that Existing Validity(if any) will be lost. Existing Data will be rolled over and Validity will be based on new Subscription`; 
      this.LaunchAlertAndProceed(textmessage);
    }
}
    if (itemName == 'Service Change') {
      if (!this.userdetail.Product.IsChangeable) {
        this.toastr.error("Change Plan is not Available for this Account", "Error")
        return;
      }
      if (producttype == unlimitedtype && planChangingTo == unlimitedtype ) {
    textmessage = `Note that your existing validity(if any) will be re-calculated based on new plan's subscription`;
   }
      if (producttype != unlimitedtype && planChangingTo == unlimitedtype ) {
    textmessage = `Note that your remaining data(if any) will be converted to Validity and added to the new plan's Validity`;
   }
   if (producttype == unlimitedtype && planChangingTo != unlimitedtype ) {
    textmessage = `Note that your existing validity(if any) will be re-calculated to data and new Validity will be based on new plan's subscription`;
   }
    this.LaunchAlertAndProceed(textmessage);
}

  }

LaunchAlertAndProceed(textmessage) {
  let value: boolean;
  Swal.fire({
      title: 'Are you sure?',
      text: textmessage,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Proceed!'
    }).then((result) => {
      if (result.value) {
        value = true;
        console.log(value);
        this.Proceeds();

      }
    });

}
  async gotoCyberPay() {
    try {
      this.processing = true;
      const userdetail = this.userdetail;

      if (userdetail == undefined) {
        this.toastr.error(environment.GenericErrorMsg, 'Error');
        this.processing = false;
        return;
      }


      const cyberpayReq: CyberPaySetTransactionRequest = {} as CyberPaySetTransactionRequest;
      cyberpayReq.Currency = 'NGN';
      cyberpayReq.Amount = this.totalAmount * 100;
      cyberpayReq.CustomerEmail = userdetail.Customer.EmailAddress;
      cyberpayReq.CustomerId = userdetail.i_customer.toString();
      cyberpayReq.CustomerMobile = userdetail.Customer.MobilePhone;
      cyberpayReq.CustomerName = `${userdetail.Customer.FirstName} ${userdetail.Customer.LastName}`;
      cyberpayReq.Description = 'Renew Data Plan ' + userdetail.ID.replace('@msisdn', '');
      cyberpayReq.IntegrationKey = environment.IntegrationKey;
      cyberpayReq.MerchantRef = new Date().getTime().toString();
      cyberpayReq.ProductCode = this.selectedPlan.i_product.toString();
      cyberpayReq.ReturnUrl = environment.CyberPayReturnURL;
      // cyberpayReq.WebhookUrl  = 'http://10.91.0.33:8080/Billing/webhook';
      cyberpayReq.WebhookUrl = environment.webhookUrl;
      console.log(cyberpayReq.ReturnUrl);

      const res = await this.paymentService.cyberPaySetTransaction(cyberpayReq).toPromise();
      if (!res.succeeded) {
        this.processing = false;
        this.toastr.error('An error occured trying to set transaction, try again', 'Error');
        return;
      }


      const cyberPayLogModel: CyberPayLogModel = {} as CyberPayLogModel;
      cyberPayLogModel.PortalCode = environment.PortalCode;
      cyberPayLogModel.CustomerID = userdetail.i_customer;
      cyberPayLogModel.DateCreated = new Date().toISOString();
      cyberPayLogModel.CustomerDesc = 'CustomerDesc';
      cyberPayLogModel.Email = cyberpayReq.CustomerEmail;


      cyberPayLogModel.FullName = userdetail.Customer.FirstName + ' ' + userdetail.Customer.LastName;

      cyberPayLogModel.ItemCode = '0';
      cyberPayLogModel.ItemName = this.renewModel.CurrentProduct.i_product == this.selectedPlan.i_product ? 'Account Renewal' : 'Service Change';

      const accRenewalSession = `Account-${userdetail.i_account}-${new Date().getTime().toString()}`;
      const serviceChangeSession = `Account-${this.selectedPlan.i_product}-${userdetail.i_account}-${this.currentUser.UserID}*${new Date().getTime().toString()}`;

      const session = cyberPayLogModel.ItemName == 'Account Renewal' ? accRenewalSession : serviceChangeSession;
      cyberPayLogModel.PhoneNumber = cyberpayReq.CustomerMobile;
      cyberPayLogModel.OperatorID = environment.OperatorID;
      cyberPayLogModel.RedirectLink = res.data.redirectUrl;
      cyberPayLogModel.Request_Payload = JSON.stringify(cyberpayReq);
      cyberPayLogModel.Session = session;
      cyberPayLogModel.TransRef = res.data.transactionReference;
      cyberPayLogModel.Transaction_status = 'PENDING';
      cyberPayLogModel.Value = this.totalAmount - this.vatModel.VAT;
      cyberPayLogModel.amount = this.totalAmount - this.vatModel.VAT;
      cyberPayLogModel.i_account = userdetail.i_account;
      cyberPayLogModel.i_customer = userdetail.i_customer;
      cyberPayLogModel.i_product = this.selectedPlan.i_product;
      cyberPayLogModel.provider_id = environment.OperatorID;
      cyberPayLogModel.AllocateAll = this.allIn;
      cyberPayLogModel.VAT = this.vatModel.VAT;
      cyberPayLogModel.VatPercentage = this.vatModel.VatPercentage;
      cyberPayLogModel.ProdVatPrice = this.vatModel.ProdVatPrice;
      cyberPayLogModel.ActualPayment = this.totalAmount;
      cyberPayLogModel.Source = 'SELFCARE-CYBERPAY';
      


      await this.paymentService.LteHttpLogCyberPayRequest(cyberPayLogModel).toPromise();
      window.location.href = res.data.redirectUrl;


    } catch (err) {
      console.log(err);
      this.processing = false;
      this.tranFailed = true;

    }


  }

  clearform() {
    this.newServicePlanId = 0;
    this.selectedPeriod = 0;
    this.paymentMethod = '';
  }

  ValidateSelectedPlan(selectedPlan: ProductResult) {
    if (selectedPlan.Price < this.renewModel.CurrentProduct.Price && this.userdetail.AccountState == 1) {
      this.toastr.error('Please exhaust your subscription before downgrading or contact our customer care for further explanations.', 'Error');
      // this.newServicePlanId = 0;

      return false;
    }

    return true;
  }





  getRenewalObject(i_account: number) {

    const model: ActiveSessionsReqObj = {} as ActiveSessionsReqObj;
    model.i_account = i_account;
    model.DownloadType = 'ACC:GetDetail';

    this.accountService.getActiveSessionsFromLteHttp(model).subscribe(res => {

      if (res.Status != 1) {
        this.toastr.error(environment.GenericErrorMsg, 'Error');
        return;
      }

      const userdetail: UserDetailResult = res.Result[0];
      this.userdetail = userdetail;
      this.renewModel.AccountMdn = userdetail.ID.toString();
      this.renewModel.CurrentProduct = userdetail.Product;
      this.renewModel.RemainingVolume = Math.round(userdetail.DataVolume).toString() + 'GB';

      this.productService.getAllProductsFromLte().subscribe(res => {

        if (res.Status != 1) {
          this.toastr.error(environment.GenericErrorMsg, 'Error');
          return;
        }

        const selfcareproduct: ProductResult[] = res.Result;

        if (this.changePlan) {

          this.filteredselfcareproduct = selfcareproduct.filter((product) => product.i_product != this.renewModel.CurrentProduct.i_product && product.Display.ShowonSelfcare === true && product.Display.CanRenew === true && product.voip_id_tariff === 0).sort((a, b) => a.Price - b.Price);

          const serviceplan: ServicePlan[] = this.filteredselfcareproduct.map(a => {
            return {
              Id: a.i_product,
              PlanName: a.Name,
              PlanAmount: a.Price.toString()
            } as ServicePlan;
          });

          this.renewModel.ServicePlanList = serviceplan;


        } else {
          // this.filteredselfcareproduct = selfcareproduct.filter((product) =>  product.Display.ShowonSelfcare === true && product.Display.CanRenew === true && product.voip_id_tariff === 0).sort((a, b) => a.Price - b.Price);
          this.productService.getSingleProductsFromLte(userdetail.Product.i_product).subscribe(res => {
            const selectedPlan = res.Result;
            this.selectedPlan = selectedPlan;

            this.newServicePlan = selectedPlan.Name + ' ' + selectedPlan.Price;
            this.newServicePlanId = selectedPlan.i_product;
            this.timeSlot = selectedPlan.Display.TimeSlot;
            this.speed = selectedPlan.Display.BustableSpeed;
            this.capacity = selectedPlan.Display.DataCapacity.Capacity.toString() + 'GB';
            this.validity = selectedPlan.Validity.toString() + 'Month';
          });

        }



        this.accountService.getCustomerBalance(userdetail.i_customer).subscribe(res => {

          if (res.Status != 1) {
            this.toastr.error(environment.GenericErrorMsg, 'Error');
            return;
          }
          this.customerBalance = Math.round(res.Result);

        });


      });

    });

  }


}
